import React from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import PushPanel from './PushPanel'
import { InlineAlert } from './PushDisabledNotice'
import { tableSx, tdStyle, thStyle, trHover } from './pushStyles'
import { fmtNum } from './pushUtils'
import type { Campaign } from './types'

const REASON_HELP: Record<string, string> = {
    UNREGISTERED: 'Token is no longer valid (app uninstalled or token expired). Token was removed.',
    INVALID_ARGUMENT: 'Firebase rejected the request or token as invalid.',
    UNAVAILABLE: 'Firebase was temporarily unavailable (retried automatically).',
    INTERNAL: 'Firebase internal error (retried automatically).',
    QUOTA_EXCEEDED: 'Firebase quota exceeded (retried automatically).',
    SENDER_ID_MISMATCH: 'Token belongs to a different Firebase project.',
    THIRD_PARTY_AUTH_ERROR: 'APNs / web push credentials problem.',
    NO_ELIGIBLE_DEVICE: 'User has no registered device that can receive push.',
}

const FailureReasons: React.FC<{ campaign: Campaign }> = ({ campaign }) => {
    const entries = Object.entries(campaign.failureReasons ?? {}).sort((a, b) => b[1] - a[1])
    return (
        <PushPanel title="Failure reasons" icon={<ErrorOutlineIcon sx={{ color: '#ff6a3d', fontSize: 20 }} />} sx={{ mb: 3 }}>
            {campaign.failureMessage && <InlineAlert severity="error" sx={{ mb: 2 }}>{campaign.failureMessage}</InlineAlert>}
            {entries.length === 0 ? (
                <Typography sx={{ fontSize: 13, color: '#6a6a6a' }}>No failures or skips recorded.</Typography>
            ) : (
                <Table size="small" sx={tableSx}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={thStyle}>Reason</TableCell>
                            <TableCell sx={thStyle}>Meaning</TableCell>
                            <TableCell sx={thStyle} align="right">Count</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {entries.map(([code, count]) => (
                            <TableRow key={code} sx={trHover}>
                                <TableCell sx={tdStyle}>{code}</TableCell>
                                <TableCell sx={{ ...tdStyle, whiteSpace: 'normal' }}>{REASON_HELP[code] ?? '-'}</TableCell>
                                <TableCell sx={tdStyle} align="right">{fmtNum(count)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            )}
        </PushPanel>
    )
}

export default FailureReasons
